import React, { useState } from 'react';
import { Phone, Menu, X, Instagram } from 'lucide-react';
import { companyInfo } from '../data/mock';
import { Button } from './ui/button';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-white shadow-md">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-10">
          {/* Logo and Nav together */}
          <div className="flex items-center gap-6">
            <img 
              src={companyInfo.logo} 
              alt="Lockout Bros Logo" 
              className="h-8 w-auto"
            />
            
            {/* Desktop Navigation */}
            <nav className="hidden md:flex items-center space-x-8">
              <a href="#services" className="text-gray-900 hover:text-yellow-500 font-medium transition-colors">
                Services
              </a>
              <a href="#why-us" className="text-gray-900 hover:text-yellow-500 font-medium transition-colors">
                Why Us
              </a>
              <a href="#coverage" className="text-gray-900 hover:text-yellow-500 font-medium transition-colors">
                Coverage Area
              </a>
              <a href="#testimonials" className="text-gray-900 hover:text-yellow-500 font-medium transition-colors">
                Reviews
              </a>
              <a href="#contact" className="text-gray-900 hover:text-yellow-500 font-medium transition-colors">
                Contact
              </a>
            </nav>
          </div>

          {/* CTA Button */}
          <div className="hidden md:flex items-center gap-4">
            <a href={companyInfo.instagram} target="_blank" rel="noopener noreferrer" className="text-gray-700 hover:text-pink-600 transition-colors">
              <Instagram className="w-6 h-6" />
            </a>
            <a href={companyInfo.phoneLink}>
              <Button className="bg-black hover:bg-gray-800 text-white px-4 py-2 text-sm font-bold flex items-center gap-2 transition-all hover:scale-105">
                <Phone className="w-4 h-4" />
                Call Us Now
              </Button>
            </a>
          </div>

          {/* Mobile Menu Button */}
          <button 
            className="md:hidden p-2"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
          >
            {isMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>

        {/* Mobile Menu */}
        {isMenuOpen && (
          <div className="md:hidden py-4 border-t">
            <nav className="flex flex-col space-y-4">
              <a href="#services" className="text-gray-900 hover:text-yellow-500 font-medium" onClick={() => setIsMenuOpen(false)}>
                Services
              </a>
              <a href="#why-us" className="text-gray-900 hover:text-yellow-500 font-medium" onClick={() => setIsMenuOpen(false)}>
                Why Us
              </a>
              <a href="#coverage" className="text-gray-900 hover:text-yellow-500 font-medium" onClick={() => setIsMenuOpen(false)}>
                Coverage Area
              </a>
              <a href="#testimonials" className="text-gray-900 hover:text-yellow-500 font-medium" onClick={() => setIsMenuOpen(false)}>
                Reviews
              </a>
              <a href="#contact" className="text-gray-900 hover:text-yellow-500 font-medium" onClick={() => setIsMenuOpen(false)}>
                Contact
              </a>
              <a href={companyInfo.phoneLink} className="w-full">
                <Button className="bg-black hover:bg-gray-800 text-white w-full py-3 text-lg font-bold flex items-center justify-center gap-2">
                  <Phone className="w-5 h-5" />
                  Call Us Now
                </Button>
              </a>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;
